import React, { createContext, useContext, useEffect, useState } from "react";

const DeviceCtx = createContext("desktop");
export const useDevice = () => useContext(DeviceCtx);
export const DEVICES = ["desktop", "tablet", "mobile"];
export const DEVICE_LABEL = { desktop: "PC WEB", tablet: "TABLET", mobile: "MOBIL" };
export const DEVICE_WIDTH = { desktop: "100%", tablet: "834px", mobile: "390px" };

export function DeviceProvider({ device, children }) {
  return <DeviceCtx.Provider value={device}>{children}</DeviceCtx.Provider>;
}

const detect = () => (window.innerWidth < 640 ? "mobile" : window.innerWidth < 1024 ? "tablet" : "desktop");
export function useViewportWidth() {
  const [w, setW] = useState(() => (typeof window !== "undefined" ? window.innerWidth : 1440));
  useEffect(() => { const on = () => setW(window.innerWidth); window.addEventListener("resize", on); return () => window.removeEventListener("resize", on); }, []);
  return w;
}
export const REF_W = { desktop: 1344, tablet: 834, mobile: 390 };
export function useAutoDevice() {
  const [d, setD] = useState(detect);
  useEffect(() => {
    const on = () => setD(detect());
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  return d;
}

// pick a value per device, falling back tablet->desktop, mobile->tablet->desktop
export const dv = (device, map) => map[device] ?? (device === "mobile" ? map.tablet ?? map.desktop : map.desktop);

const CHAIN = { desktop: [], tablet: ["tablet"], mobile: ["tablet", "mobile"] };
// Merge responsive overrides (block.responsive[device].styles / .elements) into the block for the given device.
const DEV_W = { tablet: 1024, mobile: 640 };
// Desktop-authored free positions/sizes never inherit to smaller devices (they are set per device instead).
const fits = (v) => {
  if (!v || typeof v !== "object") return v;
  const out = { ...v }; delete out.w; delete out.h; delete out.x; delete out.y; delete out.abs; return out;
};
export function resolveBlock(b, device) {
  if (device === "desktop") return b;
  const chain = device === "mobile" ? ["tablet", "mobile"] : ["tablet"];
  let styles = { ...(b.styles || {}) };
  let elements = {};
  for (const [k, v] of Object.entries(b.elements || {})) elements[k] = fits(v);
  for (const d of chain) {
    const o = b.responsive?.[d];
    if (!o) continue;
    styles = { ...styles, ...(o.styles || {}) };
    for (const [k, v] of Object.entries(o.elements || {})) elements[k] = { ...(elements[k] || {}), ...v };
  }
  return { ...b, styles, elements };
}
export const isBlockVisible = (b, device) => b.visibility?.[device] ?? true;
